/**
 * TopShelf custom card/PDP enhancements.
 *
 * NOTE: the material-style ripple that used to run on product/resource/gallery
 * cards was intentionally removed — it added click-handler + layout work to every
 * card tap and hurt tap responsiveness. The Kith MENU keeps its own, separate
 * ripple (the K() helper in menu-drawer-kith-v5.js); this file no longer touches
 * card taps at all.
 */

(function initTopshelfInteractionGatedGorgias() {
  if (window.__topshelfGorgiasInteractionGateBound) return;
  window.__topshelfGorgiasInteractionGateBound = true;

  const events = ['scroll', 'pointerdown', 'keydown', 'touchstart'];
  const loaders = [
    {
      attribute: 'data-gorgias-loader-chat',
      src: 'https://config.gorgias.chat/bundle-loader/shopify/763aab.myshopify.com',
    },
    {
      attribute: 'data-gorgias-loader-convert',
      src: 'https://content.9gtb.com/loader.js',
    },
    {
      attribute: 'data-gorgias-loader-mailto-replace',
      src: 'https://config.gorgias.help/api/contact-forms/replace-mailto-script.js?shopName=763aab',
    },
  ];
  let started = false;

  function removeListeners() {
    events.forEach((name) => window.removeEventListener(name, loadGorgias));
  }

  function loadGorgias() {
    if (started) return;
    started = true;
    removeListeners();

    loaders.forEach(({ attribute, src }) => {
      const script = document.createElement('script');
      script.setAttribute(attribute, '');
      script.src = src;
      script.async = true;
      document.head.appendChild(script);
    });
  }

  if (
    document.querySelector(
      '[data-gorgias-loader-chat], [data-gorgias-loader-convert], [data-gorgias-loader-mailto-replace]'
    )
  )
    return;

  events.forEach((name) => window.addEventListener(name, loadGorgias, { passive: true }));
})();

(function initTopshelfMobileCardVideoGuard() {
  if (window.__topshelfMobileCardVideoGuardBound) return;
  window.__topshelfMobileCardVideoGuardBound = true;

  const mq = window.matchMedia('(max-width: 749px)');
  if (!mq.matches) return;

  function removeCardVideos(root) {
    const scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('product-card[data-thumb-video]').forEach((card) => {
      card.removeAttribute('data-thumb-video');
    });
    scope.querySelectorAll('.coral-card-video').forEach((video) => {
      try {
        video.pause();
      } catch (e) {}
      video.remove();
    });
  }

  const boot = () => removeCardVideos(document);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', (e) => removeCardVideos(e.target));
})();

(function initTopshelfDescriptionAutoScroll() {
  if (window.__topshelfDescriptionAutoScrollBound) return;
  window.__topshelfDescriptionAutoScrollBound = true;

  const CONTROL_SELECTOR = '.desc-accordion__toggle, .desc-accordion__icon-button';
  if (!document.querySelector('.desc-accordion')) return;

  function getAccordion(target) {
    return target && target.closest ? target.closest('.desc-accordion') : null;
  }

  function scrollToProductTop() {
    // Horizon scrolls .page-wrapper instead of the document at 990px and up.
    const wrapper = document.querySelector('.page-wrapper');
    const container =
      wrapper && getComputedStyle(wrapper).overflowY === 'auto'
        ? wrapper
        : document.scrollingElement || document.documentElement;
    container.scrollTo({ top: 0, behavior: 'smooth' });
  }

  document.addEventListener(
    'click',
    (event) => {
      const control = event.target.closest(CONTROL_SELECTOR);
      const accordion = getAccordion(control);
      if (!accordion) return;

      const isClosing = accordion.classList.contains('is-open');
      if (!isClosing) return;

      window.setTimeout(() => {
        if (!accordion.classList.contains('is-open')) {
          scrollToProductTop();
        }
      }, 80);

      // Run once more after the accordion height transition settles so the
      // browser cannot strand the viewport near the footer after the collapse.
      window.setTimeout(() => {
        if (!accordion.classList.contains('is-open')) {
          scrollToProductTop();
        }
      }, 420);
    },
    true
  );
})();

(function initTopshelfPdpPurchaseLayout() {
  if (window.__topshelfPdpPurchaseLayoutBound) return;
  window.__topshelfPdpPurchaseLayoutBound = true;

  const ENDPOINT = 'https://storesboost-steven-beivue.laravel.cloud/api/public/wish-list';
  const TOKEN = 'PtAJM1HyT7BOFQdd3ROw1PmsrqedqTk0ZJU3DLSt';
  const IS_PDP = !!document.querySelector('.product-details, product-form-component');
  if (!IS_PDP) return;

  function getCurrentVariantGid(fallbackId) {
    const input = document.querySelector('form[action*="/cart/add"] [name="id"]');
    const id = input ? input.value : fallbackId;
    return String(id).startsWith('gid://shopify/ProductVariant/')
      ? id
      : `gid://shopify/ProductVariant/${id}`;
  }

  function attachBehavior(btn) {
    const customer = {
      id: btn.dataset.customerId,
      email: btn.dataset.customerEmail,
    };
    const fallbackVariantId = btn.dataset.variantId;

    const setButtonState = (active) => {
      btn.classList.toggle('is-active', active);
      btn.querySelector('.wishlist-text').textContent = active ? '♥ Wish Listed' : '♡ Wish List';
    };

    const readWishlist = async () => {
      try {
        const res = await fetch(`${ENDPOINT}?customer_id=${encodeURIComponent(customer.id)}`, {
          headers: { 'X-Wishlist-Token': TOKEN },
        });
        if (!res.ok) return;
        const data = await res.json();
        const gid = getCurrentVariantGid(fallbackVariantId);
        setButtonState((data?.wishlist?.variant_ids || []).includes(gid));
      } catch (e) {
        console.error(e);
      }
    };

    const toggleWishlist = async () => {
      const variant_id = getCurrentVariantGid(fallbackVariantId);
      const wasActive = btn.classList.contains('is-active');
      setButtonState(!wasActive);
      btn.disabled = true;
      try {
        const res = await fetch(`${ENDPOINT}/items`, {
          method: wasActive ? 'DELETE' : 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Wishlist-Token': TOKEN },
          body: JSON.stringify({ customer, variant_id }),
        });
        const data = await res.json();
        if (!res.ok || data?.ok === false) {
          setButtonState(wasActive);
          console.error(data);
        }
      } catch (e) {
        setButtonState(wasActive);
        console.error(e);
      } finally {
        btn.disabled = false;
      }
    };

    btn.addEventListener('click', toggleWishlist);
    readWishlist();

    document.addEventListener('change', (e) => {
      if (e.target.matches('form[action*="/cart/add"] [name="id"]')) readWishlist();
    });
  }

  function enhance() {
    document.querySelectorAll('.wishlist-button[data-customer-id]:not([data-ts-wl-bound])').forEach((btn) => {
      btn.dataset.tsWlBound = '1';
      attachBehavior(btn);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhance, { once: true });
  } else {
    enhance();
  }

  document.addEventListener('shopify:section:load', enhance);
})();

/**
 * TopShelf: keep the "SAVE $X" dollar-off badge in sync with the selected variant.
 *
 * The badge is a static custom-liquid block (snippets/topshelf-dollar-off-badge.liquid)
 * rendered with selected_or_first_available_variant, so it is only correct on initial
 * page load. Horizon's variant-picker re-fetches the product page and dispatches the
 * bubbling `shopify:product:select` event, whose `promise` resolves with the parsed new
 * HTML — we mirror the freshly rendered badge markup into the on-page wrapper. An empty
 * wrapper (no discount on the newly selected variant) naturally hides the badge. The
 * update is scoped to the section/dialog that fired the event, so a quick-add or product
 * card elsewhere on the page can never overwrite the main product's badge.
 */
(function initTopshelfDollarOffBadgeSync() {
  if (window.__topshelfDollarOffBadgeSyncBound) return;
  window.__topshelfDollarOffBadgeSyncBound = true;

  const BLOCK = '.topshelf-dollar-off-badge-block';

  document.addEventListener('shopify:product:select', (event) => {
    const promise = event?.promise;
    if (!promise || typeof promise.then !== 'function') return;
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;

    const scope = event.target.closest('.shopify-section, dialog');
    if (!scope || !scope.querySelector(BLOCK)) return;

    promise
      .then(({ detail }) => {
        const newHtml = detail?.html;
        if (!newHtml || !newHtml.querySelector) return;

        const newBlock = newHtml.querySelector(BLOCK);
        if (!newBlock) return;

        scope.querySelectorAll(BLOCK).forEach((currentBlock) => {
          currentBlock.innerHTML = newBlock.innerHTML;
        });
      })
      .catch(() => {});
  });
})();

(function initTopshelfPdpRewardsSync() {
  if (window.__topshelfPdpRewardsSyncBound) return;
  window.__topshelfPdpRewardsSyncBound = true;

  const TITLE = '.topshelf-pdp-rewards__title';
  if (!document.querySelector(TITLE)) return;

  document.addEventListener('shopify:product:select', (event) => {
    const promise = event?.promise;
    if (!promise || typeof promise.then !== 'function') return;

    const section = event.target instanceof Element ? event.target.closest('.shopify-section, dialog') : null;
    const title = (section || document).querySelector(TITLE);
    if (!title) return;

    promise
      .then(({ detail }) => {
        const price = Number(detail?.resource?.price);
        if (!Number.isFinite(price)) return;

        title.textContent = `Earn ${Math.round(price * 0.05)} Reefer Rewards Points`;
      })
      .catch(() => {});
  });
})();

/**
 * TopShelf: Subscribe & Save enhancements for the Shopify Subscriptions app block.
 *
 *   - Injects a benefits checklist (incl. a dynamic "Save $X every order" line) into
 *     each variant's subscribe card. Each variant renders its own
 *     .shopify_subscriptions_app_block section (hidden ones get --hidden), and every
 *     option carries data-variant-price / data-variant-compare-at-price, so the
 *     savings are computed per section once — no MutationObserver needed.
 *   - Pre-selects the first Subscribe & Save plan on the visible section so the page
 *     defaults to subscribe; users opt out by clicking One-time purchase.
 *   - Re-applies the default on variant change (the vendor resets to one-time), unless
 *     the shopper has explicitly made their own purchase-option choice.
 */
(function initTopshelfSubscriptions() {
  if (window.__topshelfSubscriptionsBound) return;
  window.__topshelfSubscriptionsBound = true;

  // When any variant is discounted, a server-side guard hides the entire Subscribe & Save
  // widget. Skip all enhancement/preselect so we never silently check a hidden subscription
  // plan — add-to-cart must stay a normal one-time purchase in that case.
  if (document.querySelector('.topshelf-sub-sale-guard')) return;

  const CONTAINER = '.shopify_subscriptions_app_container';
  const SECTION = '.shopify_subscriptions_app_block';
  const HIDDEN = 'shopify_subscriptions_app_block--hidden';
  const IS_PDP = !!document.querySelector('.product-details, product-form-component, ' + CONTAINER + ', ' + SECTION);
  if (!IS_PDP) return;

  function parseMoney(str) {
    if (!str) return NaN;
    const n = parseFloat(String(str).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? NaN : n;
  }
  function moneySymbol(str) {
    const m = String(str || '').match(/^\s*([^\d\s]+)/);
    return m ? m[1] : '$';
  }
  function formatMoney(symbol, value) {
    const v = Math.round(value * 100) / 100;
    return symbol + (v % 1 === 0 ? String(v) : v.toFixed(2));
  }

  function subscribeGroup(section) {
    const groups = section.querySelectorAll('.subscription_group');
    for (const g of groups) {
      if (!g.querySelector('.one_time_purchase_option_app_block')) return g;
    }
    return null;
  }

  function maxSavings(section) {
    const radios = section.querySelectorAll('input[data-radio-type="selling_plan"]');
    let best = 0;
    let symbol = '$';
    radios.forEach((r) => {
      const price = parseMoney(r.getAttribute('data-variant-price'));
      const compare = parseMoney(r.getAttribute('data-variant-compare-at-price'));
      if (!isNaN(price) && !isNaN(compare) && compare > price) {
        symbol = moneySymbol(r.getAttribute('data-variant-price'));
        best = Math.max(best, compare - price);
      }
    });
    return { amount: best, symbol: symbol };
  }

  function injectBenefits(section) {
    if (section.dataset.tsSubEnhanced) return;
    const group = subscribeGroup(section);
    if (!group) return;
    const { amount, symbol } = maxSavings(section);
    if (amount <= 0) return;

    section.dataset.tsSubEnhanced = '1';
    const ul = document.createElement('ul');
    ul.className = 'topshelf-sub-benefits';
    const items = [
      'Save up to <strong>' + formatMoney(symbol, amount) + '</strong> on every order',
      'Delivered automatically on your schedule',
      'Skip, pause, or cancel anytime — no fees',
    ];
    items.forEach((html) => {
      const li = document.createElement('li');
      li.innerHTML = html;
      ul.appendChild(li);
    });
    group.appendChild(ul);
  }

  function visibleSection(root) {
    const sections = root.querySelectorAll(SECTION);
    for (const s of sections) {
      if (!s.classList.contains(HIDDEN)) return s;
    }
    return sections[0] || null;
  }

  function preselectSubscribe(section) {
    if (!section || window.__topshelfSubUserChose) return;
    const sub = section.querySelector('input[data-radio-type="selling_plan"]');
    if (sub && !sub.checked) {
      sub.checked = true;
      sub.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function reveal() {
    document.documentElement.classList.add('ts-sub-ready');
  }

  function applyAll() {
    document.querySelectorAll(CONTAINER).forEach((root) => {
      root.querySelectorAll(SECTION).forEach(injectBenefits);
      preselectSubscribe(visibleSection(root));
    });
  }

  function reapplyVisible() {
    window.setTimeout(applyAll, 60);
  }

  // Stop overriding once the shopper makes their own real choice (incl. one-time).
  document.addEventListener('change', (e) => {
    const t = e.target;
    if (!t || !t.matches) return;
    if (t.matches('input[name^="purchaseOption"]')) {
      if (e.isTrusted) {
        // Real shopper choice — respect it, even if that's one-time.
        window.__topshelfSubUserChose = true;
      } else if (t.matches('input[data-radio-type="one_time_purchase"]')) {
        // Vendor programmatically reset to one-time → restore the subscribe default.
        reapplyVisible();
      }
      return;
    }
    // Any other change inside a product form (e.g. variant/size) → the vendor rebuilds
    // and resets to one-time, so re-apply the subscribe default to the now-visible card.
    reapplyVisible();
  });

  function boot() {
    applyAll();
    // Run one more pass on the next frame to win the vendor's deferred hydration race
    // while the widget is still hidden, then reveal — so the shopper only ever sees
    // Subscribe pre-selected (no visible one-time → subscribe flip).
    requestAnimationFrame(() => {
      applyAll();
      requestAnimationFrame(reveal);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', () => {
    applyAll();
    reveal();
  });
})();
